/**
 * Opções partilhadas: global CMS "Data e hora do site" + defaults do admin Payload (`payload.config`).
 * Pacotes: `date-fns` + `@date-fns/tz` (mesma stack que o Payload 3 usa para fusos no admin).
 */

export const DEFAULT_SITE_TIMEZONE = 'America/Sao_Paulo'

/** Fusos IANA sugeridos (labels em PT). */
export const SITE_TIMEZONE_OPTIONS: { label: string; value: string }[] = [
  { label: 'Brasília (São Paulo)', value: 'America/Sao_Paulo' },
  { label: 'Amazonas (Manaus)', value: 'America/Manaus' },
  { label: 'Ceará (Fortaleza)', value: 'America/Fortaleza' },
  { label: 'Fernando de Noronha', value: 'America/Noronha' },
  { label: 'Acre (Rio Branco)', value: 'America/Rio_Branco' },
  { label: 'UTC', value: 'UTC' },
]

/** Presets de data (tokens date-fns v4). */
export const SITE_DATE_FORMAT_PRESETS: {
  label: string
  value: string
  pattern: string
}[] = [
  { label: 'DD/MM/AAAA (ex.: 05/04/2026)', value: 'dmy_slash', pattern: 'dd/MM/yyyy' },
  { label: 'MM/DD/AAAA (estilo EUA)', value: 'mdy_slash', pattern: 'MM/dd/yyyy' },
  { label: 'AAAA-MM-DD (ISO)', value: 'ymd_dash', pattern: 'yyyy-MM-dd' },
  {
    label: 'Por extenso (5 de abril de 2026)',
    value: 'dmy_long_pt',
    pattern: "d 'de' MMMM 'de' yyyy",
  },
]

/** Presets de hora. */
export const SITE_TIME_FORMAT_PRESETS: { label: string; value: string; pattern: string }[] = [
  { label: '24 h (14:30)', value: 'h24', pattern: 'HH:mm' },
  { label: '12 h com am/pm (2:30 PM)', value: 'h12', pattern: 'hh:mm a' },
]

const datePresetMap = Object.fromEntries(SITE_DATE_FORMAT_PRESETS.map((p) => [p.value, p])) as Record<
  string,
  (typeof SITE_DATE_FORMAT_PRESETS)[number]
>

const timePresetMap = Object.fromEntries(SITE_TIME_FORMAT_PRESETS.map((p) => [p.value, p])) as Record<
  string,
  (typeof SITE_TIME_FORMAT_PRESETS)[number]
>

export function getDatePatternForPreset(presetId: string | null | undefined): string {
  const p = presetId ? datePresetMap[presetId] : undefined
  return p?.pattern ?? datePresetMap.dmy_slash.pattern
}

export function getTimePatternForPreset(presetId: string | null | undefined): string {
  const p = presetId ? timePresetMap[presetId] : undefined
  return p?.pattern ?? timePresetMap.h24.pattern
}

/** Padrão WordPress-like: data + hora numa string (site público). Literal `às` em date-fns. */
export function getCombinedDateTimePattern(datePresetId?: string | null, timePresetId?: string | null): string {
  return `${getDatePatternForPreset(datePresetId)} 'às' ${getTimePatternForPreset(timePresetId)}`
}
